import { Injectable, Signal, computed, inject, signal } from '@angular/core';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { toSignal } from '@angular/core/rxjs-interop';
import { map } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class StoreService {
  private breakpointObserver = inject(BreakpointObserver);

  private readonly isMobileBreakpoint = toSignal(
    this.breakpointObserver
      .observe(Breakpoints.Handset)
      .pipe(
        map(result => result.matches)
      ),
    { initialValue: false }
  );

  private readonly isDesktopBreakpoint = toSignal(
    this.breakpointObserver
      .observe(Breakpoints.Large)
      .pipe(
        map(result => result.matches)
      ),
    { initialValue: true }
  );

  // Computed signals públicos
  readonly isMobile: Signal<boolean> = computed(() => this.isMobileBreakpoint());
  readonly isDesktop: Signal<boolean> = computed(() => this.isDesktopBreakpoint());
} 